import Box from "@mui/material/Box";
import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { TextView } from "@components";
import { ReactComponent as CloneIcon } from "@assets/images/clone-wheel.svg";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Grid } from "@mui/material";
import HttpsIcon from "@mui/icons-material/Https";
import { Stack } from "@mui/material";
import WheelCard from "../WheelCard";
import { colors } from "../../../../utils";
export default function AllWheels({ publicWheels, onShareClick }) {
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
        onClick={(event) => {
          event.stopPropagation(); // Stops the event from propagating further
        }}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <TextView variant="text" style={{ fontSize: "8px" }}>
              {children}
            </TextView>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const tabStyle = {
    width: "33%",
    minWidth: 0,
    display: "flex",
    flexDirection: "row",
    minHeight: "4vh",
    // padding: "6px 0",
  };

  const iconStyle = {
    fontSize: {
      xs: "4vw",
      sm: "17vw",
      md: "1.5vw",
      lg: "1.25vw",
    },
    marginTop: "5px",
    marginRight: "4px",
  };

  const [tabvalue, setTabValue] = React.useState(0);

  const handleTabChange = (event, newTabValue) => {
    setTabValue(newTabValue);
  };

  const renderPublicWheels = () => {
    return (
      <>
        {publicWheels.length ? (
          <Grid container sx={{ py: 2 }}>
            {publicWheels.map((item, index) => (
              <Grid item xs={6} sm={6} key={index}>
                <WheelCard
                  onShareClick={onShareClick}
                  mainName={
                    item?.user_profile?.first_name +
                    " " +
                    item?.user_profile?.last_name
                  }
                  data={item}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box
            sx={{
              py: 5,
              backgroundColor: "#F6F7F9",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <TextView
              style={{
                fontWeight: "500",
                color: colors.primary,
                fontSize: "20px",
                lineHeight: "25px",
                textAlign: "center",
              }}
            >
              No Wheels <br></br> Available!
            </TextView>
          </Box>
        )}
      </>
    );
  };

  const renderClonedWheels = () => {
    return (
      <Box
        sx={{
          py: 5,
          backgroundColor: "#F6F7F9",
          borderRadius: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextView
          style={{
            fontWeight: "500",
            color: colors.primary,
            fontSize: "20px",
            lineHeight: "25px",
            textAlign: "center",
          }}
        >
          No Wheels To <br></br> Show For Now!
        </TextView>
      </Box>
    );
  };

  const renderPrivateWheels = () => {
    return (
      <Box
        sx={{
          py: 5,
          backgroundColor: "#F6F7F9",
          borderRadius: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextView
          style={{
            fontWeight: "500",
            color: colors.primary,
            fontSize: "20px",
            lineHeight: "25px",
            textAlign: "center",
          }}
        >
          No Wheels To <br></br> Show For Now!
        </TextView>
      </Box>
    );
  };

  return (
    <>
      <Box
        sx={{
          // width: "95vw",
          backgroundColor: "white",
          borderRadius: "10px",
          margin: "10px",
          padding: "10px",
          paddingBottom: tabvalue === 4 ? "5px" : "0px",
          zIndex: 1000,
          mb: 10,
        }}
      >
        {/* <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabvalue}
          onChange={handleTabChange}
          aria-label="basic tabs example"
          variant="scrollable" // Add this line to make tabs scrollable on smaller screens
          scrollButtons="auto" // Add this line to have scroll buttons automatically appear
        >
          <Tab
            sx={tabStyle}
            icon={<VisibilityOutlinedIcon sx={iconStyle} />}
            label={tabvalue === 0 && "Public"}
            {...a11yProps(0)}
          />
          <Tab
            sx={tabStyle}
            icon={
              <CloneIcon
                style={{
                  height: "20px",
                  width: "20px",
                  marginTop: "5px",
                  marginRight: "4px",
                }}
              />
            }
            label={tabvalue === 1 && "Cloned"}
            {...a11yProps(1)}
          />
          <Tab
            sx={tabStyle}
            icon={<HttpsIcon sx={iconStyle} />}
            label={tabvalue === 2 && "Private"}
            {...a11yProps(2)}
          />
        </Tabs>
      </Box> */}
        <TextView
          style={{
            fontWeight: "700",
            color: colors.darkGrey,
            fontSize: "22px",
            lineHeight: "25px",
            margin: "5px",
          }}
        >
          Public Wheels ({publicWheels.length})
        </TextView>

        {tabvalue === 0
          ? renderPublicWheels()
          : tabvalue === 1
          ? renderClonedWheels()
          : tabvalue === 2
          ? renderPrivateWheels()
          : null}
      </Box>
    </>
  );
}
